import React from "react";
import { RouteComponentProps } from "@reach/router";
import styled from "styled-components";
import moment from "moment";
import Covers from "pages/Covers";
import axios from "axios";
import OnTop from "pages/OnTop";

const Wrapper = styled.div`
  background: #f1f1f1;
  padding: 20px;

  min-height: 90vh;
  border-radius: 5px;

  .img-responsive {
    height: 250px;
    width: 100%;
  }
`

const Title = styled.div`
  font-size: 30px;
  color: var(--primary-color);
  font-weight: bold;
`

const Date = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  color: var(--secondary-color);
  padding: 15px 0;
`

const ArticleCover = styled.div`
  height: 250px;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;
  background-position: 100%;
`

export const Desc = styled.p`
  background-color: #fff;
  padding: 10px 10px;
  border-left: 3px solid #FF4C28;
`

interface IProps extends RouteComponentProps {
  slug?: string;
}

export default function SheetPage({ slug }: IProps) {
  const [sheet, setSheet] = React.useState(null);

  React.useEffect(() => {
    axios('/api/v1/articles/student_life/public/slug/' + slug)
      .then(res => {
        setSheet(res.data)
      });
  }, []);

  return (
    <>
      <Covers page="student_life_home" />

      <div className="container">
        <br />
        <div className="row">
          <div className="col-md-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/">Accueil</a></li>
                <li className="breadcrumb-item"><a href="/vie-etudiante">Vie Etudiante</a></li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <br />
            <Wrapper>
              <Title>{sheet?.name}</Title>
              <Date>{moment(sheet?.createdAt).format('MMMM DD, YYYY')}</Date>
              {
                sheet?.description &&
                <Desc>{sheet?.description}</Desc>
              }

              {
                sheet?.cover_image &&
                <ArticleCover style={{ backgroundImage: `url(${sheet?.cover_image})` }} />
              }
              <br />
              <div dangerouslySetInnerHTML={{ __html: sheet?.presentation }}></div>
            </Wrapper>
            <br />
          </div>
          <div className="col-md-4">
            <br />
            <OnTop section="student_life" />
            <br />
          </div>
        </div>
      </div>
    </>
  )
}
